import { CreateReleaseNoteRequest } from '@src/main/modules/parameters/infrastructure/dto/createUpdateReleaseNoteRequest';
import { createReleaseNoteHttpRepository } from '@src/main/modules/parameters/infrastructure/repository/ReleaseNoteHttpRepository';
import { useAuth } from '@src/main/shared/context/AuthContext';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useCallback, useMemo } from 'react';

export const useCreateReleaseNote = () => {
  const { user } = useAuth();
  const queryClient = useQueryClient();

  const getToken = useCallback(async () => user?.token ?? '', [user?.token]);
  const tokenProvider = useMemo(() => ({ getToken }), [getToken]);

  const repository = useMemo(() => {
    if (!user?.token) return null;
    return createReleaseNoteHttpRepository(tokenProvider);
  }, [user?.token, tokenProvider]);

  return useMutation({
    mutationFn: async (data: CreateReleaseNoteRequest) => {
      if (!repository) throw new Error('Repository not initialized');
      return await repository.create(data);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['release-notes'] });
    },
  });
};
